module.exports = __webpack_public_path__ + "img/2025-06-11b_3.5e8bf059.jpg";